<template>
    <div class="w">
        <div class="fa_l clearfix mt35">
            <dl class="fa_dl" v-for="(item,index) in cate.slice(0,6)" :key="item.id">
                <dt>
                    <img width="62" height="62" :src="item.icon">
                    <h3 class="fa_h3">
                        <a href="javascript:;" @click="catesearch(item.title,index)" class="f14 c3">{{item.title}}</a>
                    </h3>
                </dt>
                <dd v-for="items in item.z" :key="items.id">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:items.id}}" target="_blank" class="b_aa">
                        <p>{{items.title}}</p>
                    </router-link>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
/*引入公共方法*/
export default {
    data(){
        return{
            cate:[],
            type: 1,
            icon:[
                {icon:require("../../assets/picture/bottom/fn2.png")},
                {icon:require("../../assets/picture/bottom/fn1.png")},
                {icon:require("../../assets/picture/bottom/fn6.png")},
                {icon:require("../../assets/picture/bottom/fn4.png")},
                {icon:require("../../assets/picture/bottom/fn3.png")},
                {icon:require("../../assets/picture/bottom/fn5.png")},
            ],
            //全部商品分类
            allCategory:
            [
                {
                    name:"男性用品",
                    url:"javascript:;",
                    src:require("../../assets/picture/48.jpg"),
                    children:[
                        {name:"飞机杯",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"自感软胶",url:"javascript:;",src:require("../../assets/picture/49.jpg")},
                        {name:"臀胸倒模",url:"javascript:;",src:require("../../assets/picture/48.jpg")},
                        {name:"实体娃娃",url:"javascript:;",src:require("../../assets/picture/4.jpg")},
                    ]
                },
                {
                    name:"女性用品",
                    url:"javascript:;",
                    src:require("../../assets/picture/64.jpg"),
                    children:[
                        {name:"情趣跳蛋",url:"javascript:;",src:require("../../assets/picture/64.jpg")},
                        {name:"仿真阳具",url:"javascript:;",src:require("../../assets/picture/7.jpg")},
                        {name:"震动棒",url:"javascript:;",src:require("../../assets/picture/197.jpg")},
                        {name:"胸部挑逗",url:"javascript:;",src:require("../../assets/picture/62.jpg")},
                        {name:"隐形穿戴",url:"javascript:;",src:require("../../assets/picture/115.jpg")},
                        {name:"紧致缩阴",url:"javascript:;",src:require("../../assets/picture/115.jpg")},
                        {name:"阴蒂刺激",url:"javascript:;",src:require("../../assets/picture/115.jpg")},
                    ]
                },
                {
                    name:"套套世界",
                    url:"javascript:;",
                    src:require("../../assets/picture/26.jpg"),
                    children:[
                        {name:"杜蕾斯",url:"javascript:;",src:require("../../assets/picture/26.jpg")},
                        {name:"第六感",url:"javascript:;",src:require("../../assets/picture/98.jpg")},
                        {name:"杰士邦",url:"javascript:;",src:require("../../assets/picture/56.jpg")},
                    ]
                },
                {
                    name:"助兴用品",
                    url:"javascript:;",
                    src:require("../../assets/picture/3.jpg"),
                    children:[
                        {name:"外用延时",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"女用快感",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"润滑滋养",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"情趣套套",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                    ]
                },
                {
                    name:"另类玩具",
                    url:"javascript:;",
                    src:require("../../assets/picture/3.jpg"),
                    children:[
                        {name:"G点后庭",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"SM套装",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                        {name:"情趣服饰",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                    ]
                },
                {
                    name:"特惠专区",
                    url:"javascript:;",
                    src:require("../../assets/picture/3.jpg"),
                    children:[
                        {name:"每日特惠",url:"javascript:;",src:require("../../assets/picture/3.jpg")},
                    ]
                },
            ],
        }
    },
    mounted() {
        this.getShopCate();
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.cate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            item.icon=this.icon[index].icon
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 5){
                this.$router.push(`/biyuntao/`);
            }else if(index == 2){
                this.$router.push(`/zhuxing/`);
            }else if(index == 3){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 4){
                this.$router.push(`/tehui/`);
            }
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/bottom-nav.vue